import { cn } from '@app/utils/cn';

import { ArrowDown } from '../Icons';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  rotation?: number;
  size?: number;
  type: 'up' | 'down';
}

export const Trend = ({ type, className, ...rest }: Props) => {
  return (
    <ArrowDown
      className={cn(
        {
          'rotate-180 text-success-47': type === 'up',
          'text-error-45': type !== 'up',
        },
        className,
      )}
      {...rest}
    />
  );
};
